"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode_value = encode_value;
const buffer_1 = require("buffer");
const asn1_1 = __importDefault(require("@chromia/asn1"));
const bn_js_1 = __importDefault(require("bn.js"));
const ASNDictPair = asn1_1.default.define("DictPair", function () {
    this.seq().obj(this.key("name").utf8str(), this.key("value").use(GTV_ASN));
});
const GTV_ASN = asn1_1.default.define('GTV', function () {
    this.choice({
        null: this.explicit(0).null_(),
        byteArray: this.explicit(1).octstr(),
        string: this.explicit(2).utf8str(),
        integer: this.explicit(3).int(),
        dict: this.explicit(4).seqof(ASNDictPair),
        array: this.explicit(5).seqof(GTV_ASN),
        bigInteger: this.explicit(6).int(),
    });
});
function encode_value(value) {
    const asn = to_asn_object(value);
    return GTV_ASN.encode(asn, 'der');
}
function to_asn_object(value) {
    try {
        if (value == null) {
            return { type: "null", value: null };
        }
        if (buffer_1.Buffer.isBuffer(value)) {
            return { type: "byteArray", value: value };
        }
        if (typeof value === "boolean") {
            return { type: "integer", value: value ? 1 : 0 };
        }
        if (typeof value === "string") {
            return { type: "string", value: value };
        }
        if (typeof value === "number") {
            if (!Number.isInteger(value)) {
                throw Error("User error: Only integers are supported");
            }
            return { type: "integer", value: new bn_js_1.default(value) };
        }
        if (typeof value === "bigint") {
            const val = new bn_js_1.default(value.toString());
            return { type: "bigInteger", value: val };
        }
        if (value.constructor === Array) {
            return {
                type: "array",
                value: value.map(item => to_asn_object(item)),
            };
        }
        if (typeof value === "object") {
            let valueAsDictPair = value;
            valueAsDictPair = sortDictPairByKey(valueAsDictPair);
            return {
                type: "dict",
                value: Object.keys(valueAsDictPair).map(function (key) {
                    return { name: key, value: to_asn_object(valueAsDictPair[key]) };
                }),
            };
        }
    }
    catch (error) {
        const message = value ? value.toString() : "RawGtv";
        throw new Error(`Failed to encode ${message}: ${error}`);
    }
    throw new Error(`value ${value} have unsupported type: ${typeof value}`);
}
function sortDictPairByKey(dict) {
    const sortedArray = Object.entries(dict).sort(([keyA], [keyB]) => {
        if (keyA < keyB) {
            return -1;
        }
        if (keyA > keyB) {
            return 1;
        }
        return 0;
    });
    const sortedDict = {};
    for (const [key, value] of sortedArray) {
        sortedDict[key] = value;
    }
    return sortedDict;
}
//# sourceMappingURL=utils.js.map